var React = require('react');

function FacebookLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1365.3332992 682.6666504C1365.3332992 305.63999316 1059.69330684 8e-7 682.6666496 8e-7S0 305.63999316 0 682.6666504c0 340.73865815 249.6413271 623.15985109 575.9999856 674.37342314V879.9999788h-173.333329V682.6666504h173.333329V532.26665416c0-171.09332906 101.91733079-265.59999336 257.85332689-265.59999336 74.68933146 0 152.81332951 13.333333 152.81332951 13.333333v167.9999958h-86.08266451c-84.80399788 0-111.25066389 52.62266535-111.25066389 106.60933067V682.6666504h189.3333286l-30.26666591 197.3333284H789.3333136v477.04009474c326.3586585-51.21357205 575.9999856-333.634765 575.9999856-674.37342314"}));
}

FacebookLogo.defaultProps = {"height":"100%","viewBox":"0 0 1365.3333 1365.3333"};

module.exports = FacebookLogo;

FacebookLogo.default = FacebookLogo;
